import Slider from 'react-slick';
import SectionTitle from "../SectionTitle/SectionTitle";
import ProjectCard from './ProjectCard';
import Projects from "../../api/projects";


const ProjectSection = (props) => {



    const settings = {
        centerMode: true,
        centerPadding: '0px',
        infinite: true,
        centerPadding: '0px',
        speed: 200,
        autoplay:true,
        autoplaySpeed:2000,

        dots: true,
        arrows:false,
        variableWidth:true,
        responsive: [{
            breakpoint: 575,
            settings: {
                slidesToShow: 2,
                variableWidth: false,
                centerMode: true,
                centerPadding: '0px',
            }
        },
      
    
        ]
    };


    return (
        <section className={"" + props.hclass}>
            <div className="container">
                <div className="row justify-content-center my-5">
                    <div className="col-12">
                        <SectionTitle subtitle="Our Trusted Clients" title="Empowering Global Businesses" />
                    </div>
                </div>
            </div>
            <div className="project-slider" style={{marginTop:"-60px"}} >
                <Slider {...settings}>
                    {Projects.map((item, Pindx) => (
                        <div key={Pindx}>
                            <ProjectCard Pimg={item.pimg1} Psubtitle={item.subtitle} Ptitle={item.title} Pslug={item.slug} />
                        </div>
                    ))}
                </Slider>

            </div>
        </section>
    )
}

export default ProjectSection;











